const StatCard = ({ icon: Icon, label, value, accent = "primary" }) => {
  const accentClasses = {
    primary: "text-primary bg-primary/10",
    secondary: "text-secondary bg-secondary/10",
    success: "text-success bg-success/10",
  };

  return (
    <div className="bg-bg-surface border border-border rounded-2xl p-6 flex items-center gap-4 card-hover">
      <div className={`w-11 h-11 rounded-full flex items-center justify-center ${accentClasses[accent]}`}>
        <Icon size={20} />
      </div>
      <div>
        <p className="text-text-muted text-xs uppercase tracking-wider">{label}</p>
        <p className="text-text-primary text-2xl font-bold">{value}</p>
      </div>
    </div>
  );
};

export default StatCard;
